module.exports = __webpack_public_path__ + "img/logo-text.11bb30ec.png";